import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Item } from '../../common/snippets'
import { ReportHeading } from './common/ReportHeading'
import * as sx from '../../common/stylesInline/report_daily_branch'
import * as id from './reportId'
import * as lb from './reportLables'
import DropDownOA from '../../common/dropDownOA'
import Datepicker from '../../common/datePicker'
import { Box, Button, Paper, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import { RefreshSvg } from '../../common/svg/refresh'
import { SplitButton } from '../../common/SplitButton'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { Table } from '@mui/material'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import moment from 'moment'
import { getBranchList } from '../../../store/common/common_action'
import { getBranchWiseCollectionData, getOwnChildBranches } from '../../../store/reports/reports_action'
import DropDownMultiSelect from '../../common/dropDownMultiSelect'
import { appendToUrl, focusElemnt, isEmpty, navigation2, navigation3 } from '../../common/helper'
import Alert from '../../common/alert'
import * as urls from './oldReportsUrls'
import { PaymentTypesOptions, TransactionTypeOption } from '../../common/constants'
import { callAddFontRobotoBold } from '../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../common/font/Roboto-Medium-normal'
import BranchwiseCollectionExcel from './Branchwise/BranchwiseCollectionExcel'
import { paymentModes } from '../../common/paymentsMode'
import { companySettingsAtom } from '../../common/jotaiState/commonStateAtoms'
import { useAtom } from 'jotai'
const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
const SummaryTable = (props) => {
    const { index, row, columnDefs ,UseToPayAsCOD} = props;
    return row.isDataRow ?
        <TableRow key={`DR-${index}`}>
            <TableCell size='small' style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px' }}>{row.transaction}</TableCell>
            <TableCell size='small' style={{ minHeight: '36px', textAlign: 'right', fontSize: '12px' }}>{Number(row.PaidAmt).toLocaleString('en-IN')}</TableCell>
            <TableCell size='small' style={{ minHeight: '36px', textAlign: 'right', fontSize: '12px' }}>{Number(row.PaidManAmt).toLocaleString('en-IN')}</TableCell>
            <TableCell size='small' style={{ minHeight: '36px', textAlign: 'right', fontSize: '12px' }}>{Number(row.TopayAmt).toLocaleString('en-IN')}</TableCell>
            <TableCell size='small' style={{ minHeight: '36px', textAlign: 'right', fontSize: '12px' }}>{Number(row.TopayManAmt).toLocaleString('en-IN')}</TableCell>
            <TableCell size='small' style={{ minHeight: '36px', textAlign: 'right', fontSize: '12px' }}>{Number(row.DDDVAmt).toLocaleString('en-IN')}</TableCell>
            <TableCell size='small' style={{ minHeight: '36px', textAlign: 'right', fontSize: '12px' }}>{Number(row.OnAccAmt).toLocaleString('en-IN')}</TableCell>
            {UseToPayAsCOD!==1&&<TableCell size='small' style={{ minHeight: '36px', textAlign: 'right', fontSize: '12px' }}>{Number(row.CODAmt).toLocaleString('en-IN')}</TableCell>}
            <TableCell size='small' style={{ minHeight: '36px', textAlign: 'right', fontSize: '12px' }}>{Number(row.SelfAmt).toLocaleString('en-IN')}</TableCell>
            <TableCell size='small' style={{ minHeight: '36px', textAlign: 'right', fontSize: '12px' }}>{Number(row.FOCAmt).toLocaleString('en-IN')}</TableCell>
            <TableCell size='small' style={{ minHeight: '36px', textAlign: 'right', fontSize: '12px' }}>{Number(row.totalAmt).toLocaleString('en-IN')}</TableCell>
        </TableRow>
        : row.isHeaderRow ?
            <TableRow key={`TH-${index}`}>
                {columnDefs.map((col, index) => (
                    <TableCell size='small' style={{ ...col.headerSx, minHeight: '36px', backgroundColor: '#daedfe', fontSize: '12px', fontWeight: 'bold', color: '#444', whiteSpace: 'nowrap' }} key={`tth-${col.field}${index}`}>{col.headerName}</TableCell>
                ))}
            </TableRow>
            : row.isSubHeadingRow ?
                <TableRow key={`SHRT-${index}`}>
                    {row.isSubHeadingData.map((obj, index) => (
                        <TableCell size='small' style={{ minHeight: '36px', backgroundColor: '#f1f9ff', fontSize: '12px', fontWeight: 'bold', textAlign: obj.align, color: '#444' }} key={`SH-${index}`} colSpan={obj.colSpan} >{`${obj.caption}${obj.value}`}</TableCell>
                    ))}
                </TableRow>
                : row.isTotalRow ?
                    <TableRow key={`TOH-${index}`}>
                        <TableCell size='small' style={{ minHeight: '36px', backgroundColor: '#eeeeee', fontSize: '12px', fontWeight: 'bold', color: '#444' }}>{row.caption}</TableCell>
                        <TableCell size='small' style={{ minHeight: '36px', backgroundColor: '#eeeeee', fontSize: '12px', fontWeight: 'bold', color: '#444' }} align='right'>{Number(row.totalPaid).toLocaleString('en-IN')}</TableCell>
                        <TableCell size='small' style={{ minHeight: '36px', backgroundColor: '#eeeeee', fontSize: '12px', fontWeight: 'bold', color: '#444' }} align='right'>{Number(row.totalPaidManual).toLocaleString('en-IN')}</TableCell>
                        <TableCell size='small' style={{ minHeight: '36px', backgroundColor: '#eeeeee', fontSize: '12px', fontWeight: 'bold', color: '#444' }} align='right'>{Number(row.totalToPay).toLocaleString('en-IN')}</TableCell>
                        <TableCell size='small' style={{ minHeight: '36px', backgroundColor: '#eeeeee', fontSize: '12px', fontWeight: 'bold', color: '#444' }} align='right'>{Number(row.totalToPayManual).toLocaleString('en-IN')}</TableCell>
                        <TableCell size='small' style={{ minHeight: '36px', backgroundColor: '#eeeeee', fontSize: '12px', fontWeight: 'bold', color: '#444' }} align='right'>{Number(row.totalToPayDDDV).toLocaleString('en-IN')}</TableCell>
                        <TableCell size='small' style={{ minHeight: '36px', backgroundColor: '#eeeeee', fontSize: '12px', fontWeight: 'bold', color: '#444' }} align='right'>{Number(row.totalOnAccount).toLocaleString('en-IN')}</TableCell>
                        {UseToPayAsCOD!==1&& <TableCell size='small' style={{ minHeight: '36px', backgroundColor: '#eeeeee', fontSize: '12px', fontWeight: 'bold', color: '#444' }} align='right'>{Number(row.totalCOD).toLocaleString('en-IN')}</TableCell>}
                        <TableCell size='small' style={{ minHeight: '36px', backgroundColor: '#eeeeee', fontSize: '12px', fontWeight: 'bold', color: '#444' }} align='right'>{Number(row.totalSelfBooking).toLocaleString('en-IN')}</TableCell>
                        <TableCell size='small' style={{ minHeight: '36px', backgroundColor: '#eeeeee', fontSize: '12px', fontWeight: 'bold', color: '#444' }} align='right'>{Number(row.totalFOC).toLocaleString('en-IN')}</TableCell>
                        <TableCell size='small' style={{ minHeight: '36px', backgroundColor: '#eeeeee', fontSize: '12px', fontWeight: 'bold', color: '#444' }} align='right'>{Number(row.totalAmt).toLocaleString('en-IN')}</TableCell>
                    </TableRow>
                    : row.isNoData ?
                        <TableRow key={`RR-${index}`}>
                            <TableCell size='small' colSpan={row.colSpan} align='center' style={{ minHeight: '36px', fontSize: '12px', }}>{row.caption}</TableCell>
                        </TableRow>
                        : null
}
const DetailedTable = (props) => {
    const { index, row, columnDetailedBok, columnDetailedDel, columnDetailedRef } = props;
    return row.isDataRow ?
        <TableRow key={`DR-${index}`}>
            <TableCell size='small' style={{ minHeight: '36px', textAlign: 'center', fontSize: '12px' }}>{row.SNo}</TableCell>
            <TableCell size='small' style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px' }}>{row.LRNO}&nbsp;</TableCell>
            <TableCell size='small' style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px' }}>{row.Date}</TableCell>
            <TableCell size='small' style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px' }}>{row.SourceCity}</TableCell>
            <TableCell size='small' style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px' }}>{row.DestinationCity}</TableCell>
            <TableCell size='small' style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px' }}>{row.PaymentType}</TableCell>
            <TableCell size='small' style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px' }}>{row.ConsignmentType}</TableCell>
            <TableCell size='small' style={{ minHeight: '36px', textAlign: 'right', fontSize: '12px' }}>{Number(row.Quantity).toLocaleString('en-IN')}</TableCell>
            <TableCell size='small' style={{ minHeight: '36px', textAlign: 'right', fontSize: '12px' }}>{Number(row.Freight).toLocaleString('en-IN')}</TableCell>
            <TableCell size='small' style={{ minHeight: '36px', textAlign: 'right', fontSize: '12px' }}>{Number(row.OtherCharges).toLocaleString('en-IN')}</TableCell>
            <TableCell size='small' style={{ minHeight: '36px', textAlign: 'right', fontSize: '12px' }}>{Number(row.GST).toLocaleString('en-IN')}</TableCell>
            <TableCell size='small' style={{ minHeight: '36px', textAlign: 'right', fontSize: '12px' }}>{Number(row.NetAmount).toLocaleString('en-IN')}</TableCell>
            <TableCell size='small' style={{ minHeight: '36px', textAlign: 'left', fontSize: '12px' }}>{row.Remarks}</TableCell>
        </TableRow>
        : row.isHeaderRow ? row.isBooking ?
            <TableRow key={`TH-${index}`} style={{position: 'sticky'}}>
                {columnDetailedBok.map((col) => (
                    <TableCell size='small' style={{ ...col.headerSx, minHeight: '36px', position: 'sticky', top: "58px", backgroundColor: '#daedfe', fontSize: '12px', fontWeight: 'bold', color: '#444', whiteSpace: 'nowrap' }} key={`th-${col.field}`}>{col.headerName}</TableCell>
                ))}
            </TableRow> : row.isDelivery ? <TableRow key={`TH-${index}`}>
                {columnDetailedDel.map((col) => (
                    <TableCell size='small' style={{ ...col.headerSx, minHeight: '36px', position: 'sticky', top: "58px", backgroundColor: '#daedfe', fontSize: '12px', fontWeight: 'bold', color: '#444', whiteSpace: 'nowrap' }} key={`th-${col.field}`}>{col.headerName}</TableCell>
                ))}
            </TableRow> : row.isRefund ? <TableRow key={`TH-${index}`}>
                {columnDetailedRef.map((col) => (
                    <TableCell size='small' style={{ ...col.headerSx, minHeight: '36px', position: 'sticky', top: "58px", backgroundColor: '#daedfe', fontSize: '12px', fontWeight: 'bold', color: '#444', whiteSpace: 'nowrap' }} key={`th-${col.field}`}>{col.headerName}</TableCell>
                ))}
            </TableRow> : null
            : row.isSupHeadingRow ?
                <TableRow key={`SHRT-${index}`} style={{position: 'sticky'}}>
                    {row.isSubHeadingData.map((obj, index) => (
                        <TableCell size='small' style={{ minHeight: '36px', backgroundColor: '#f1f9ff', position: 'sticky', top: "30px", fontSize: '12px', fontWeight: 'bold', color: '#444', textAlign: obj.align }} key={`SH-${index}`} colSpan={obj.colSpan} >{`${obj.caption}${obj.value}`}</TableCell>
                    ))}
                </TableRow>
            : row.isSubHeadingRow ?
                <TableRow key={`SHRT-${index}`}>
                    {row.isSubHeadingData.map((obj, index) => (
                        <TableCell size='small' style={{ minHeight: '36px', backgroundColor: '#f1f9ff', top: "30px", fontSize: '12px', fontWeight: 'bold', color: '#444', textAlign: obj.align }} key={`SH-${index}`} colSpan={obj.colSpan} >{`${obj.caption}${obj.value}`}</TableCell>
                    ))}
                </TableRow>
                : row.isTotalRow ?
                    <TableRow key={`TOR-${index}`}>
                        <TableCell size='small' style={{ minHeight: '36px', backgroundColor: '#eeeeee', fontSize: '12px', fontWeight: 'bold', color: '#444', textAlign: 'right' }} colSpan={row.colSpan}>{row.caption}</TableCell>
                        <TableCell size='small' style={{ minHeight: '36px', backgroundColor: '#eeeeee', fontSize: '12px', fontWeight: 'bold', color: '#444' }} align='right'>{Number(row.totalUnits).toLocaleString('en-IN')}</TableCell>
                        <TableCell size='small' style={{ minHeight: '36px', backgroundColor: '#eeeeee', fontSize: '12px', fontWeight: 'bold', color: '#444' }} align='right'>{Number(row.totalFreight).toLocaleString('en-IN')}</TableCell>
                        <TableCell size='small' style={{ minHeight: '36px', backgroundColor: '#eeeeee', fontSize: '12px', fontWeight: 'bold', color: '#444' }} align='right'>{Number(row.totalOtherCharges).toLocaleString('en-IN')}</TableCell>
                        <TableCell size='small' style={{ minHeight: '36px', backgroundColor: '#eeeeee', fontSize: '12px', fontWeight: 'bold', color: '#444' }} align='right'>{Number(row.totalGST).toLocaleString('en-IN')}</TableCell>
                        <TableCell size='small' style={{ minHeight: '36px', backgroundColor: '#eeeeee', fontSize: '12px', fontWeight: 'bold', color: '#444' }} align='right'>{Number(row.totalAmt).toLocaleString('en-IN')}</TableCell>
                        <TableCell size='small' style={{ minHeight: '36px', backgroundColor: '#eeeeee', fontSize: '12px', fontWeight: 'bold', color: '#444' }} align='right'>{''}</TableCell>
                    </TableRow>
                    : row.isNoData ?
                        <TableRow key={`RR-${index}`}>
                            <TableCell size='small' colSpan={row.colSpan} align='center' style={{ minHeight: '36px', fontSize: '12px', }}>{row.caption}</TableCell>
                        </TableRow>
                        : null
}

const BranchwiseCollection = (props) => {
    const {
        data: { common, reports },
        getBranchWiseCollectionData,
        getOwnChildBranches,
    } = props
    const { loginData, roleRights } = common
    const [companySettings] = useAtom(companySettingsAtom)
    const UseToPayAsCOD=companySettings?.UseToPayAsCOD
    const { ownChildBranches } = reports
    const [generatereport, setGeneratereport] = useState(0)
    const [tableData, setTableData] = useState([])
    const [fromDate, setFromDate] = useState(moment(new Date()))
    const [toDate, setToDate] = useState(moment(new Date()))
    const [selBranch, setSelBranch] = useState('')
    const [selTransactionType, setSelTransactionType] = useState([])
    const [selPaymentType, setSelPaymentType] = useState([])
    const [isPdfLoading, setIsPdfLoading] = useState(false)
    const [resetFlag, setResetFlag] = useState(false)
    const [showAlert, setShowAlert] = useState({
        show: false,
        message: ''
    })
    const [showTable, setShowTable] = useState(false)
    const [state, setState] = useState({
        generatePDF: false,
        load: false,
    })
    const [filterData, setFilterData] = useState({
        FromDate: '',
        ToDate: '',
        CompanyName: '',
        BranchName: '',
        transaction: '',
        payment: '',
    });
    const reportViewData = [
        { view: 'Detailed', id: 0 },
        { view: 'Summary', id: 1 },
    ]
    const [reportView, setReportView] = useState(reportViewData[0])
    const [disableBtn, setDisableBtn] = useState(false)
    const [disableExcel, setDisableExcel] = useState(false)
    const [paymentTypeOpt, setPaymentTypeOpt] = useState([])
    const [columnDefsForSummary, setColumnDefsForSummary] = useState([]);
    // for Header columns' title
    const columnDetailedBok = [
        { headerName: 'Serial Number', exportHead: 'Serial Number', field: 'SNo', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '50px', textAlign: 'center' } },
        { headerName: 'LR Number', exportHead: 'LR Number', field: 'LRNO', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'left' } },
        { headerName: 'Booking Date', exportHead: 'Booking Date', field: 'Date', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'left' } },
        { headerName: 'Source', exportHead: 'Source', field: 'SourceCity', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'left' } },
        { headerName: 'Destination', exportHead: 'Destination', field: 'DestinationCity', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'left' } },
        { headerName: 'Payment Type', exportHead: 'Payment Type', field: 'PaymentType', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'left' } },
        { headerName: 'Consignment Type', exportHead: 'Consignment Type', field: 'ConsignmentType', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'left' } },
        { headerName: 'Units', exportHead: 'Units', field: 'Quantity', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Freight', exportHead: 'Freight', field: 'Freight', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Other Charges', exportHead: 'Other Charges', field: 'OtherCharges', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Booking GST', exportHead: 'Booking GST', field: 'GST', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Total Amount', exportHead: 'Total Amount', field: 'NetAmount', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Remarks', exportHead: 'Remarks', field: 'Remarks', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'left' } },
    ]
    const columnDetailedDel = [
        { headerName: 'Serial Number', exportHead: 'Serial Number', field: 'SNo', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '50px', textAlign: 'center' } },
        { headerName: 'LR Number', exportHead: 'LR Number', field: 'LRNO', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'left' } },
        { headerName: 'Delivery Date', exportHead: 'Delivery Date', field: 'Date', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'left' } },
        { headerName: 'Source', exportHead: 'Source', field: 'SourceCity', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'left' } },
        { headerName: 'Destination', exportHead: 'Destination', field: 'DestinationCity', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'left' } },
        { headerName: 'Payment Type', exportHead: 'Payment Type', field: 'PaymentType', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'left' } },
        { headerName: 'Consignment Type', exportHead: 'Consignment Type', field: 'ConsignmentType', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'left' } },
        { headerName: 'Units', exportHead: 'Units', field: 'Quantity', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Total LR Amt', exportHead: 'Total LR Amt', field: 'Freight', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Net Charge', exportHead: 'Net Charge', field: 'OtherCharges', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Delivery GST', exportHead: 'Delivery GST', field: 'GST', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Total Amount', exportHead: 'Total Amount', field: 'NetAmount', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Remarks', exportHead: 'Remarks', field: 'Remarks', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'left' } },
    ]
    const columnDetailedRef = [
        { headerName: 'Serial Number', exportHead: 'Serial Number', field: 'SNo', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '50px', textAlign: 'center' } },
        { headerName: 'LR Number', exportHead: 'LR Number', field: 'LRNO', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'left' } },
        { headerName: 'Refund Date', exportHead: 'Date', field: 'Refund Date', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'left' } },
        { headerName: 'Source', exportHead: 'Source', field: 'SourceCity', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '100px', textAlign: 'left' } },
        { headerName: 'Destination', exportHead: 'Destination', field: 'DestinationCity', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'left' } },
        { headerName: 'Payment Type', exportHead: 'Payment Type', field: 'PaymentType', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'left' } },
        { headerName: 'Consignment Type', exportHead: 'Consignment Type', field: 'ConsignmentType', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'left' } },
        { headerName: 'Units', exportHead: 'Units', field: 'Quantity', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Freight', exportHead: 'Freight', field: 'Freight', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Other Charges', exportHead: 'Other Charges', field: 'OtherCharges', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Refund GST', exportHead: 'Refund GST', field: 'GST', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Total Amount', exportHead: 'Total Amount', field: 'NetAmount', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Remarks', exportHead: 'Remarks', field: 'Remarks', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'left' } },
    ]
    const columnSummaryDefs = [
        { headerName: 'Transactions', exportHead: 'Transactions', field: 'transaction', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '150px', textAlign: 'left' } },
        { headerName: 'Paid', exportHead: 'Paid', field: 'PaidAmt', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Paid Manual', exportHead: 'Paid Manual', field: 'PaidManAmt', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'ToPay', exportHead: 'ToPay', field: 'TopayAmt', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'ToPay Manual', exportHead: 'ToPay Manual ', field: 'TopayManAmt', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'ToPay DDDV', exportHead: 'ToPay DDDV', field: 'DDDVAmt', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'On Account', exportHead: 'On Account', field: 'OnAccAmt', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'COD', exportHead: 'COD', field: 'CODAmt', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Self Booking', exportHead: 'Self Booking', field: 'SelfAmt', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'FOC', exportHead: 'FOC', field: 'FOCAmt', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
        { headerName: 'Total Amount', exportHead: 'Total Amount', field: 'totalAmt', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { minWidth: '80px', textAlign: 'right' } },
    ];
    const filterHeader = [
        { headerName: 'Branch', dataKey: "BranchName", colSpan: 4 },
        { headerName: 'Transaction Type', dataKey: "transaction", colSpan: 4 },
        { headerName: 'Payment Type', dataKey: "payment", colSpan: generatereport ? 3 : 5 },
    ]
    useEffect(() => {
        let updatedColumns = columnSummaryDefs.map(col => ({ ...col }));
        if (UseToPayAsCOD === 1) {
            updatedColumns = updatedColumns.map(col => {
                switch (col.field) {
                    case 'TopayAmt':
                        return { ...col, headerName: 'COD', exportHead: 'COD' };
                    case 'TopayManAmt':
                        return { ...col, headerName: 'COD Manual', exportHead: 'COD Manual' };
                    case 'DDDVAmt':
                        return { ...col, headerName: 'COD DDDV', exportHead: 'COD DDDV' };
                    default:
                        return col;
                }
            });
            updatedColumns = updatedColumns.filter(col => col.field !== 'CODAmt');
        }
        setColumnDefsForSummary(updatedColumns);
    }, [UseToPayAsCOD]);
    useEffect(() => {
        if (!isEmpty(roleRights) && !isEmpty(loginData)) {
            setDisableBtn(!(roleRights?.Table1?.[0]?.AllowViewAllBranchReport || loginData?.IsBranchAdmin || loginData?.IsMTPLAdmin || loginData?.IsAdmin))
            setDisableExcel(!(roleRights?.Table1?.[0]?.AllowExportExcel))
        }
    }, [roleRights, loginData])
    useEffect(() => {
        if (!isEmpty(roleRights)) {
            let updatedPayTypeData = [];
            if ((roleRights?.Table) && roleRights.Table.length > 0) {
                const obj = roleRights?.Table.filter((val) => val.BookingRightsID == 1)?.[0] || {};
                const payTypeData = paymentModes.filter((val) => obj[val.roleRightsId] === 1);
                updatedPayTypeData = [{ typeId: 0, type: "ALL", name: "All", f: 'none', b: 'none', isEnabled: true }, ...payTypeData];
            } else {
                updatedPayTypeData = [{ typeId: 0, type: "ALL", name: "All", f: 'none', b: 'none', isEnabled: true }, ...paymentModes];
            }
            if (UseToPayAsCOD === 1) {
                const toPayIndex = updatedPayTypeData.findIndex(item => item.typeId === 2);
                const codOption = updatedPayTypeData.find(item => item.typeId === 4);
                if (toPayIndex !== -1 && codOption) {
                    updatedPayTypeData[toPayIndex] = {
                        ...codOption,
                        typeId: 2,
                        name: "COD",
                        roleRightsId: "COD"
                    };
                }
                updatedPayTypeData = updatedPayTypeData.filter(item => item.typeId !== 4);
            }
            setPaymentTypeOpt(updatedPayTypeData);
        }
    }, [roleRights, UseToPayAsCOD]);
    useEffect(() => {
        focusElemnt(id.fromDate)
    }, [])
    const handleClick1 = (type) => {
        if (selBranch === '' || selBranch === ' ') {
            setShowAlert({ show: true, message: "Please select Branch" })
        } else if (selTransactionType.length === 0) {
            setShowAlert({ show: true, message: " Please select Transaction" })
        } else if (selPaymentType.length === 0) {
            setShowAlert({ show: true, message: " Please select Payment Type" })
        } else if (moment(toDate).endOf('day').valueOf() - moment(fromDate).startOf('day').valueOf() > (31 * 24 * 60 * 60 * 1000)) {
            setShowAlert({ show: true, message: "This report cannot be taken for more than 31 days" })
        } else if (reportView === '' || reportView === ' ') {
            setShowAlert({ show: true, message: " Please select Report View" })
        } else {
            let url = urls.branchWiseCollection
            const urlData = urls.branchWiseCollectionParams
            urlData.chk = loginData.BusCrsCheckSum
            urlData.intCompanyId = loginData.intCompanyID
            urlData.FromDate = fromDate.format('YYYY-MM-DD')
            urlData.ToDate = toDate.format('YYYY-MM-DD')
            urlData.BranchId = selBranch.BranchID
            urlData.Summary = type.id
            urlData.BranchName = selBranch.BranchName
            urlData.intAllowExportToExcel = 1
            url = appendToUrl(url, urlData)
            window.open(url, '_blank')
        }
    }

    useEffect(() => {
        if (!isEmpty(loginData)) {
            const branchData = {
                intUserID: 0,
                intCompanyID: loginData?.intCompanyID,
                intIsActive: 1,
            }
            getOwnChildBranches(branchData, true, 24 * 60 * 60 * 1000)
        }
    }, [loginData])

    const [defaultBranch, setDefaultBranch] = useState('')
    useEffect(() => {
        if (ownChildBranches.length > 0) {
            let filterData = ownChildBranches.filter((obj) => obj.BranchID == loginData?.intBranchID)
            if (filterData.length > 0) {
                setDefaultBranch(filterData[0].BranchName)
                setSelBranch(filterData[0])
            }
        }
    }, [ownChildBranches])
    // for print and export pdf
    const printReport = (isSave = false) => {
        setState({ ...state, load: true, generatePDF: true })
        setIsPdfLoading(true);
        jsPDF.API.events.push(["addFonts", callAddFontRobotoBold]);
        jsPDF.API.events.push(["addFonts", callAddFontRobotoMedium]);
        const doc = new jsPDF({ orientation: 'p', format: [1120, 1585], unit: 'px', compress: true })
        const HeaderColumns = [
            { header: 'Branch', dataKey: 'branch', xlCol: { dataType: 'string' } },
            { header: 'Transaction Type', dataKey: 'transactionsType', xlCol: { dataType: 'string' } },
            { header: 'Payment Type', dataKey: 'paymentType', xlCol: { dataType: 'string' } },
        ]
        const HeaderData = [{
            branch: filterData.BranchName,
            transactionsType: filterData.transaction,
            paymentType: filterData.payment,
        }]
        autoTable(doc, {
            margin: { top: 60, left: 30, right: 30, bottom: 5 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: HeaderColumns,
            body: HeaderData,
            styles: {
                font: 'Roboto',
            },
            startY: 160,
            columnStyles: {
                0: { fontSize: 18, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: 140, valign: 'middle', font: 'Roboto', halign: 'left', fontStyle: 'normal' },
                1: { fontSize: 18, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: 140, valign: 'middle', font: 'Roboto', halign: 'left', fontStyle: 'normal' },
                2: { fontSize: 18, textColor: [0, 0, 0], cellPadding: 12, minCellHeight: 36, minCellWidth: 140, valign: 'middle', font: 'Roboto', halign: 'left', fontStyle: 'normal' },
            },
            theme: 'grid',
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                minCellHeight: 36,
                valign: 'middle',
                cellPadding: 12,
                fontSize: 18,
                fontStyle: 'normal',
                lineWidth: 0.6,
            },
            didDrawPage: function (data) {
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(18).setFont('Roboto', 'bold')
                doc.text(`Collection Date: ${moment(filterData.FromDate).format('DD-MMM-YYYY')} To ${moment(filterData.ToDate).format('DD-MMM-YYYY')}`, data.settings.margin.left, 150)
                doc.text(`Report View: ${generatereport ? 'Summary' : 'Detailed'}`, doc.internal.pageSize.width - data.settings.margin.left, 150, "right")
            },
            showHead: "firstPage",
        })
        let pdfColumns = []
        if (generatereport) {
            pdfColumns = columnDefsForSummary.map((col) => {
                return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
            })
        } else {
            pdfColumns = columnDetailedBok.map((col) => {
                return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
            })
        }
        var totalPagesExp = '{total_pages_count_string}'
        let drawCell = function (data) {
            var rows = data.table.body;

            rows.forEach((val) => {
                if (!val.cells) return; // skip if cells is undefined

                if (val.raw.isSubHeadingRow || val.raw.isSupHeadingRow) {
                    if (val.raw.isSubHeadingData?.length > 0) {
                        let prevColSpan = 0;
                        val.raw.isSubHeadingData.forEach((obj) => {
                            if (val.cells[prevColSpan]) {  // ✅ check existence
                                val.cells[prevColSpan].text = `${obj.caption}${obj.value}`;
                                val.cells[prevColSpan].colSpan = obj.colSpan;
                                val.cells[prevColSpan].styles.font = 'Roboto';
                                val.cells[prevColSpan].styles.halign = obj.align;
                                val.cells[prevColSpan].styles.valign = "middle";
                            }
                            prevColSpan += obj.colSpan;
                        });
                    }
                } else if (val.raw.isTotalRow) {
                    let prevColSpan = 0;
                    for (let key in val.raw) {
                        if (!val.cells[prevColSpan]) continue; // ✅ check existence
                        val.cells[prevColSpan].styles.valign = 'middle';
                        if (key === 'caption') {
                            val.cells[prevColSpan].text = val.raw.caption.toString();
                            val.cells[prevColSpan].colSpan = val.raw.colSpan;
                            val.cells[prevColSpan].styles.halign = val.raw.align;
                            prevColSpan += val.raw.colSpan;
                        } else if (!['isTotalRow', 'colSpan', 'align'].includes(key)) {
                            val.cells[prevColSpan].text = val.raw[key]?.toFixed?.(2) || val.raw[key];
                            prevColSpan += 1;
                        }
                    }
                } else if (val.raw.isNoData) {
                    if (val.cells[0]) {
                        val.cells[0].text = val.raw.caption.toString();
                        val.cells[0].colSpan = val.raw.colSpan;
                        val.cells[0].styles.halign = 'center';
                        val.cells[0].styles.valign = 'middle';
                    }
                } else if (val.raw.isPrintHeading) {
                    if (val.cells[0]) {
                        val.cells[0].text = val.raw.caption + val.raw.value;
                        val.cells[0].colSpan = val.raw.colSpan;
                        val.cells[0].styles.halign = val.raw.align;
                        val.cells[0].styles.valign = 'middle';
                    }
                }
            });
        };

        const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {

            const doc = data.doc
            // Footer
            var pageSize = doc.internal.pageSize
            var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
            var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

            var str = 'Page : ' + doc.internal.getNumberOfPages()
            if (typeof doc.putTotalPages === 'function') {
                str = str + ' of ' + totalPagesExp
            }
            doc.setFontSize(16)
            doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, "right")
            doc.setFont('Roboto', 'bold')
            doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
            doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
        }
        doc.setProperties({
            title: `Branchwise Collection.pdf`,
            subject: 'Branchwise Collection Report',
            author: 'Maven Tech Labs Pvt. Ltd.',
            keywords: 'maven tech, Cargo system, Branchwise',
            creator: 'MTLPL',
        })
        autoTable(doc, {
            margin: { top: 120, left: 30, right: 30, bottom: 40 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: pdfColumns,
            tableLineWidth: 0.6,
            body: tableData,
            styles: {
                lineWidth: [0, 0.2, 0, 0.2]
            },
            columnStyles: generatereport ? {
                0: { fontSize: 16, textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', minCellWidth: 30, minCellHeight: 36, fontStyle: 'normal', valign: "middle", halign: 'left' },
                1: { fontSize: 16, textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', minCellWidth: 10, minCellHeight: 36, fontStyle: 'normal', valign: "middle", halign: 'right' },
                2: { fontSize: 16, textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', minCellWidth: 10, minCellHeight: 36, fontStyle: 'normal', valign: "middle", halign: 'right' },
                3: { fontSize: 16, textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', minCellWidth: 10, minCellHeight: 36, fontStyle: 'normal', valign: "middle", halign: 'right' },
                4: { fontSize: 16, textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', minCellWidth: 10, minCellHeight: 36, fontStyle: 'normal', valign: "middle", halign: 'right' },
                5: { fontSize: 16, textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', minCellWidth: 18, minCellHeight: 36, fontStyle: 'normal', valign: "middle", halign: 'right' },
                6: { fontSize: 16, textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', minCellWidth: 10, minCellHeight: 36, fontStyle: 'normal', valign: "middle", halign: 'right' },
                7: { fontSize: 16, textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', minCellWidth: 10, minCellHeight: 36, fontStyle: 'normal', valign: "middle", halign: 'right' },
                8: { fontSize: 16, textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', minCellWidth: 10, minCellHeight: 36, fontStyle: 'normal', valign: "middle", halign: 'right' },
                9: { fontSize: 16, textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', minCellWidth: 10, minCellHeight: 36, fontStyle: 'normal', valign: "middle", halign: 'right' },
                10: { fontSize: 16, textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', minCellWidth: 10, minCellHeight: 36, fontStyle: 'normal', valign: "middle", halign: 'right' }
            } : {
                0: { fontSize: 16, textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', minCellWidth: 5, minCellHeight: 36, fontStyle: 'normal', valign: "middle", halign: 'right' },
                1: { fontSize: 16, textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', minCellWidth: 24, minCellHeight: 36, fontStyle: 'normal', valign: "middle", halign: 'left' },
                2: { fontSize: 16, textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', minCellWidth: 18, minCellHeight: 36, fontStyle: 'normal', valign: "middle", halign: 'left' },
                3: { fontSize: 16, textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', minCellWidth: 12, minCellHeight: 36, fontStyle: 'normal', valign: "middle", halign: 'left' },
                4: { fontSize: 16, textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', minCellWidth: 12, minCellHeight: 36, fontStyle: 'normal', valign: "middle", halign: 'left' },
                5: { fontSize: 16, textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', minCellWidth: 8, minCellHeight: 36, fontStyle: 'normal', valign: "middle", halign: 'left' },
                6: { fontSize: 16, textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', minCellWidth: 22, minCellHeight: 36, fontStyle: 'normal', valign: "middle", halign: 'left' },
                7: { fontSize: 16, textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', minCellWidth: 8, minCellHeight: 36, fontStyle: 'normal', valign: "middle", halign: 'right' },
                8: { fontSize: 16, textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', minCellWidth: 10, minCellHeight: 36, fontStyle: 'normal', valign: "middle", halign: 'right' },
                9: { fontSize: 16, textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', minCellWidth: 10, minCellHeight: 36, fontStyle: 'normal', valign: "middle", halign: 'right' },
                10: { fontSize: 16, textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', minCellWidth: 15, minCellHeight: 36, fontStyle: 'normal', valign: "middle", halign: 'right' },
                11: { fontSize: 16, textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', minCellWidth: 10, minCellHeight: 36, fontStyle: 'normal', valign: "middle", halign: 'right' },
                12: { fontSize: 16, textColor: [0, 0, 0], cellPadding: 6, font: 'Roboto', minCellWidth: 10, minCellHeight: 36, fontStyle: 'normal', valign: "middle", halign: 'left' }
            },
            theme: 'grid',
            headStyles: {
                fillColor: [191, 225, 255],
                fontSize: 16,
                minCellHeight: 36,
                cellPadding: 6,
                valign: 'middle',
                fontStyle: 'normal',
                font: 'Roboto'
            },
            didParseCell: (data) => {
                drawCell(data)
            },
            willDrawCell: (data) => {
                if (data.row.raw.isHeaderRow) {
                    doc.setFillColor(191, 225, 255);
                    doc.setTextColor(0, 0, 0);
                    doc.setFontSize(16).setFont("Roboto", 'normal')
                    data.cell.styles.valign = 'middle';
                }
                else if (data.row.raw.isSubHeadingRow) {
                    doc.setFillColor(241, 249, 255);
                    doc.setTextColor(0, 0, 0);
                    doc.setFontSize(16).setFont("Roboto", 'normal')
                } else if (data.row.raw.isTotalRow) {
                    doc.setFillColor(238, 238, 238);
                    doc.setTextColor(0, 0, 0);
                    doc.setFontSize(16).setFont("Roboto", 'normal')
                } else if (data.row.raw.isPrintHeading) {
                    doc.setFillColor(191, 225, 255);
                    doc.setTextColor(0, 0, 0);
                    doc.setFontSize(16).setFont("Roboto", 'normal')
                }
            },
            didDrawPage: function (data) {
                doc.setTextColor(40)
                doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
                doc.setFontSize(26).setFont("Roboto", 'bold')
                doc.setTextColor(16, 79, 162)
                doc.text('Cargo System | Branchwise Collection Report', 30 + 60, 80)
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(22).setFont("Roboto", 'bold')
                doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, "right")
                jsPdfHeaderFooter(data, loginData, totalPagesExp)
            },
            showHead: "never",

        })
        doc.setFont('Roboto')
        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp)
        }
        if (isSave) {
            doc.save(`Branchwise Collection ${currentDateTime}.pdf`)
        }
        setTimeout(() => {
            setState({ ...state, generatePDF: false, load: true })
            const pdfUrl = doc.output('bloburl')
            document.getElementById('output').data = pdfUrl
            // document.getElementById('output').data = doc.output('datauristring', 'Branchwise Collection.pdf')
            focusElemnt('backbtn')
        }, 2000)

    }
    // Back 
    const backToScreenView = () => {
        setIsPdfLoading(false);
        const data = document.getElementById('output')
        data.innerHTML = ''
    }

    //Generate report
    const generateBanchWiseReport = () => {
        setTableData([])
        setShowTable(false);
        setGeneratereport(reportView.id)
        if (selBranch === '' || selBranch === ' ') {
            setShowAlert({ show: true, message: "Please select Branch" })
        } else if (selTransactionType.length === 0) {
            setShowAlert({ show: true, message: " Please select Transaction" })
        } else if (selPaymentType.length === 0) {
            setShowAlert({ show: true, message: " Please select Payment Type" })
        } else if (moment(toDate).endOf('day').valueOf() - moment(fromDate).startOf('day').valueOf() > (31 * 24 * 60 * 60 * 1000)) {
            setShowAlert({ show: true, message: "This report cannot be taken for more than 31 days" })
        } else if (reportView === '' || reportView === ' ') {
            setShowAlert({ show: true, message: " Please select Report View" })
        } else {
            setTableData([])
            setIsPdfLoading(false);
            const body = {
                CompanyID: loginData.intCompanyID,
                BranchID: selBranch.BranchID,
                UserID: loginData.intUserID,
                dtFrom: moment(new Date(fromDate)).format("YYYY-MM-DD"),
                dtTo: moment(new Date(toDate)).format("YYYY-MM-DD"),
                Modes: selTransactionType.length != TransactionTypeOption.length ? selTransactionType.reduce((data, obj) => { if (obj.id !== 'All') { data.push(obj.id); } return data }, []).join('^') : 'All',
                //PaymentTypeIDs: selPaymentType.length != PaymentTypesOptions.length ? selPaymentType.reduce((data, obj) => { if (obj.id !== 0) { data.push(obj.id); } return data }, []).join('^') : 0,
                PaymentTypeIDs: selPaymentType.length != paymentTypeOpt.length ? selPaymentType.reduce((data, obj) => { if (obj.typeId !== 0) { data.push(obj.typeId); } return data }, []).join('^') : 0,

            }
            setFilterData((prev) => ({
                ...prev,
                FromDate: moment(new Date(fromDate)).format("YYYY-MM-DD"),
                ToDate: moment(new Date(toDate)).format("YYYY-MM-DD"),
                CompanyName: loginData.strCompanyName,
                BranchName: selBranch.BranchName,
                transaction: selTransactionType.length != TransactionTypeOption.length ? selTransactionType.reduce((data, obj) => { if (obj.id !== 'All') { data.push(obj.Name); } return data }, []).join(',') : 'All',
                payment: selPaymentType.length != paymentTypeOpt.length ? selPaymentType.reduce((data, obj) => { if (obj.typeId !== 0) { data.push(obj.name); } return data }, []).join(',') : "All",
                //  payment: selPaymentType.length != PaymentTypesOptions.length ? selPaymentType.reduce((data, obj) => { if (obj.id !== 0) { data.push(obj.Name); } return data }, []).join(',') : "All",
            }))

            getBranchWiseCollectionData(body).then((val) => {
                if (reportView.view === 'Summary') {
                    formatData(val.Data, reportView, selTransactionType)
                } else {
                    const updatedData = {
                        ...val,
                        Data: {
                            ...val.Data,
                            Table: val.Data.Table.map((item) => ({
                                ...item,
                                PaymentType:
                                    UseToPayAsCOD === 1 && item.PaymentType === "To-Pay"
                                        ? "COD"
                                        : item.PaymentType,
                            })),
                        },
                    };
                    formatDataTwo(updatedData.Data, selTransactionType);
                }
                setShowTable(true)
            })
        }
    }

    const formatData = (data, type, txnType) => {
        if (type.id) {
            let summaryData = []
            let bookingData = [];
            let deliveryData = [];
            let refundData = [];
            let totalBookingAndDelivery = {
                totalPaid: 0,
                totalPaidManual: 0,
                totalToPay: 0,
                totalToPayManual: 0,
                totalToPayDDDV: 0,
                totalOnAccount: 0,
                totalCOD: 0,
                totalSelfBooking: 0,
                totalFOC: 0,
                totalAmt: 0,
            }
            let totalRow = {
                totalPaid: 0,
                totalPaidManual: 0,
                totalToPay: 0,
                totalToPayManual: 0,
                totalToPayDDDV: 0,
                totalOnAccount: 0,
                totalCOD: 0,
                totalSelfBooking: 0,
                totalFOC: 0,
                totalAmt: 0,
            } 
            
            let printHeader = {
                isPrintHeading: true,
                caption: "Summary View", value: `(${data.Table2[0].Branchname})`, colSpan: 11, align: 'left'
            }
            let subHeaderRow = {
                isSubHeadingRow: true, isSubHeadingData: [
                    { caption: 'State:', value: data.Table2[0].Statename, colSpan: 5, align: 'left' },
                    { caption: 'City Name:', value: data.Table2[0].Cityname, colSpan: 6, align: 'right' }
                ]
            }
            let headerRow = {
                isHeaderRow: true,
                transaction: 'Transactions',
                PaidAmt: 'Paid',
                PaidManAmt: 'Paid Manual',
                TopayAmt: UseToPayAsCOD === 1 ? 'COD' : 'ToPay',
                TopayManAmt: UseToPayAsCOD === 1 ? 'COD Manual' : 'ToPay Manual',
                DDDVAmt: UseToPayAsCOD === 1 ? 'COD DDDV' : 'ToPay DDDV',
                OnAccAmt: 'On Account',
                CODAmt: 'COD',
                SelfAmt: 'Self Booking',
                FOCAmt: 'FOC',
                totalAmt: 'Total Amount'
            };
            if (UseToPayAsCOD === 1 && headerRow.hasOwnProperty('CODAmt')) {
                delete headerRow.CODAmt;
            }
            data.Table1.forEach((val, index) => {
                const totatAmt = val.PaidAmt + val.PaidManAmt + val.TopayAmt + val.TopayManAmt + val.OnAccAmt + val.CODAmt + val.SelfAmt + val.FOCAmt;
                if (val.TYPE === "R") {
                    refundData.push({ isDataRow: true, ...val, transaction: `${val.TransactionType}(C)`, totalAmt: totatAmt })
                } else if (val.TYPE === 'D') {
                    deliveryData.push({ isDataRow: true, ...val, transaction: `${val.TransactionType}(B)`, totalAmt: totatAmt })
                } else if (val.TYPE === 'B') {
                    bookingData.push({ isDataRow: true, ...val, transaction: `${val.TransactionType}(A)`, totalAmt: totatAmt })
                }
                totalRow = {
                    totalPaid: val.TYPE == 'R' ? totalRow.totalPaid - val.PaidAmt : totalRow.totalPaid + val.PaidAmt,
                    totalPaidManual: val.TYPE == 'R' ? totalRow.totalPaidManual - val.PaidManAmt : totalRow.totalPaidManual + val.PaidManAmt,
                    totalToPay: val.TYPE == 'R' ? totalRow.totalToPay - val.TopayAmt : totalRow.totalToPay + val.TopayAmt,
                    totalToPayManual: val.TYPE == 'R' ? totalRow.totalToPayManual - val.TopayManAmt : totalRow.totalToPayManual + val.TopayManAmt,
                    totalToPayDDDV: val.TYPE == 'R' ? totalRow.totalToPayDDDV - val.DDDVAmt : totalRow.totalToPayDDDV + val.DDDVAmt,
                    totalOnAccount: val.TYPE == 'R' ? totalRow.totalOnAccount - val.OnAccAmt : totalRow.totalOnAccount + val.OnAccAmt,
                    totalCOD: val.TYPE == 'R' ? totalRow.totalCOD - val.CODAmt : totalRow.totalCOD + val.CODAmt,
                    totalSelfBooking: val.TYPE == 'R' ? totalRow.totalSelfBooking - val.SelfAmt : totalRow.totalSelfBooking + val.SelfAmt,
                    totalFOC: val.TYPE == 'R' ? totalRow.totalFOC - val.FOCAmt : totalRow.totalFOC + val.FOCAmt,
                    totalAmt: val.TYPE == 'R' ? totalRow.totalAmt - totatAmt : totalRow.totalAmt + totatAmt,
                }
                totalBookingAndDelivery = {
                    totalPaid: val.TYPE == 'R' ? totalBookingAndDelivery.totalPaid : totalBookingAndDelivery.totalPaid + val.PaidAmt,
                    totalPaidManual: val.TYPE == 'R' ? totalBookingAndDelivery.totalPaidManual : totalBookingAndDelivery.totalPaidManual + val.PaidManAmt,
                    totalToPay: val.TYPE == 'R' ? totalBookingAndDelivery.totalToPay : totalBookingAndDelivery.totalToPay + val.TopayAmt,
                    totalToPayManual: val.TYPE == 'R' ? totalBookingAndDelivery.totalToPayManual : totalBookingAndDelivery.totalToPayManual + val.TopayManAmt,
                    totalToPayDDDV: val.TYPE == 'R' ? totalBookingAndDelivery.totalToPayDDDV : totalBookingAndDelivery.totalToPayDDDV + val.DDDVAmt,
                    totalOnAccount: val.TYPE == 'R' ? totalBookingAndDelivery.totalOnAccount : totalBookingAndDelivery.totalOnAccount + val.OnAccAmt,
                    totalCOD: val.TYPE == 'R' ? totalBookingAndDelivery.totalCOD : totalBookingAndDelivery.totalCOD + val.CODAmt,
                    totalSelfBooking: val.TYPE == 'R' ? totalBookingAndDelivery.totalSelfBooking : totalBookingAndDelivery.totalSelfBooking + val.SelfAmt,
                    totalFOC: val.TYPE == 'R' ? totalBookingAndDelivery.totalFOC : totalBookingAndDelivery.totalFOC + val.FOCAmt,
                    totalAmt: val.TYPE == 'R' ? totalBookingAndDelivery.totalAmt : totalBookingAndDelivery.totalAmt + totatAmt,
                }
            })
            let findAllOpt = selTransactionType.length == TransactionTypeOption.length;
            let findBokOpt = selTransactionType.find((obj) => obj.id == 'B');
            let findDelOpt = selTransactionType.find((obj) => obj.id == 'D');
            let findRefOpt = selTransactionType.find((obj) => obj.id == 'R');
            summaryData.push(printHeader, subHeaderRow, headerRow)
            let noRowData = { isDataRow: true, PaidAmt: 0, PaidManAmt: 0, TopayAmt: 0, TopayManAmt: 0, DDDVAmt: 0, OnAccAmt: 0, CODAmt: 0, SelfAmt: 0, FOCAmt: 0, totalAmt: 0}
            if (findAllOpt || findBokOpt !== undefined) {
                if (bookingData.length > 0) {
                    summaryData.push(...bookingData)
                } else {
                    summaryData.push({ ...noRowData, transaction: 'Booking(A)' })
                }
            }
            if (findAllOpt || findDelOpt !== undefined) {
                if (deliveryData.length > 0) {
                    summaryData.push(...deliveryData)
                } else {
                    summaryData.push({ ...noRowData, transaction: 'Delivery(B)' })
                }
            }
            if (findAllOpt || findBokOpt !== undefined || findDelOpt !== undefined) {
                summaryData.push({ isTotalRow: true, caption: `Total Collection ${`(${findBokOpt != undefined ? 'A' : ''}${findDelOpt != undefined ? findBokOpt != undefined ? '+B' : 'B' : ''})`} `, colSpan: 1, ...totalBookingAndDelivery })
            }
            if (findAllOpt || findRefOpt !== undefined) {
                if (refundData.length > 0) {
                    summaryData.push(...refundData)
                } else {
                    summaryData.push({ ...noRowData, transaction: 'Refund(C)' })
                }
                summaryData.push({ isTotalRow: true, caption: `Net Collection ${findAllOpt ? '(A+B-C)' : `(${findBokOpt != undefined ? 'A' : ''}${findDelOpt != undefined ? findBokOpt != undefined ? '+B' : 'B' : ''}${findRefOpt != undefined ? findRefOpt != undefined ? '-C' : 'C' : ''})`} `, colSpan: 1, ...totalRow })
            }
            setTableData([...summaryData])
        } else {
            let bookingData = [];
            let deliveryData = [];
            let refundData = [];
            let totalRowBooking = {
                totalUnits: 0,
                totalFreight: 0,
                totalOtherCharges: 0,
                totalGST: 0,
                totalAmt: 0,
            }
            let totalRowDelviery = {
                totalUnits: 0,
                totalFreight: 0,
                totalOtherCharges: 0,
                totalGST: 0,
                totalAmt: 0,
            }
            let totalRowRefund = {
                totalUnits: 0,
                totalFreight: 0,
                totalOtherCharges: 0,
                totalGST: 0,
                totalAmt: 0,
            }
            let grantTotal = {
                totalUnits: 0,
                totalFreight: 0,
                totalOtherCharges: 0,
                totalGST: 0,
                totalAmt: 0,
            }
            let bookingHeader = { isHeaderRow: true, isBooking: true, SNo: "S/N", LRNO: 'LR No', Date: 'Bkg. Date', SourceCity: 'Source', DestinationCity: 'Destination', PaymentType: "Pymt. Type", ConsignmentType: 'Cons. Type', Quantity: 'Units', Freight: 'Freight', OtherCharges: 'Other Chrgs.', GST: "Bkg.GST", NetAmount: "Total Amt.", Remarks: 'Remarks'}
            let deliveryHeader = { isHeaderRow: true, isDelivery: true, SNo: "S/N", LRNO: 'LR No', Date: 'Del. Date', SourceCity: 'Source', DestinationCity: 'Destination', PaymentType: "Pymt. Type", ConsignmentType: 'Cons. Type', Quantity: 'Units', Freight: 'Total LR Amt.', OtherCharges: 'Net Chrgs.', GST: "Delivery GST", NetAmount: "Total Amt.", Remarks: 'Remarks'}
            let refundHeader = { isHeaderRow: true, isRefund: true, SNo: "S/N", LRNO: 'LR No', Date: 'Refund Date', SourceCity: 'Source', DestinationCity: 'Destination', PaymentType: "Pymt. Type", ConsignmentType: 'Cons. Type', Quantity: 'Units', Freight: 'Freight', OtherCharges: 'Other Chrgs.', GST: "Refund GST", NetAmount: "Total Amt.", Remarks: 'Remarks'}

            let bookingSubHeading = {
                isSubHeadingRow: true, isSubHeadingData: [
                    { caption: 'Branch:', value: data.Table2[0].Branchname, colSpan: 4, align: 'left' },
                    { caption: 'Transactions:', value: 'Booking', colSpan: 2, align: 'left' },
                    { caption: 'State:', value: data.Table2[0].Statename, colSpan: 3, align: 'right' },
                    { caption: 'City Name:', value: data.Table2[0].Cityname, colSpan: 3, align: 'right' },
                ]
            }
            let deliverySubHeading = {
                isSubHeadingRow: true, isSubHeadingData: [
                    { caption: 'Branch:', value: data.Table2[0].Branchname, colSpan: 4, align: 'left' },
                    { caption: 'Transactions:', value: 'Delivery', colSpan: 2, align: 'left' },
                    { caption: 'State:', value: data.Table2[0].Statename, colSpan: 3, align: 'right' },
                    { caption: 'City Name:', value: data.Table2[0].Cityname, colSpan: 3, align: 'right' },
                ]
            }
            let refundSubHeading = {
                isSubHeadingRow: true, isSubHeadingData: [
                    { caption: 'Branch:', value: data.Table2[0].Branchname, colSpan: 4, align: 'left' },
                    { caption: 'Transactions:', value: 'Refund', colSpan: 2, align: 'left' },
                    { caption: 'State:', value: data.Table2[0].Statename, colSpan: 3, align: 'right' },
                    { caption: 'City Name:', value: data.Table2[0].Cityname, colSpan: 3, align: 'right' },
                ]
            }
            data.Table.forEach((val) => {
                if (val.TransType === 'B') {
                    bookingData.push({ isDataRow: true, SNo: bookingData.length + 1, ...val, Date: moment(new Date(val.BookingDate)).format("DD-MMM-YY") });
                    totalRowBooking = {
                        totalUnits: totalRowBooking.totalUnits + val.Quantity,
                        totalFreight: totalRowBooking.totalFreight + val.Freight,
                        totalOtherCharges: totalRowBooking.totalOtherCharges + val.OtherCharges,
                        totalGST: totalRowBooking.totalGST + val.GST,
                        totalAmt: totalRowBooking.totalAmt + val.NetAmount,
                    }
                } else if (val.TransType === 'D') {
                    deliveryData.push({ isDataRow: true, SNo: deliveryData.length + 1, ...val, Date: moment(new Date(val.TransDateTime)).format("DD-MMM-YY") })
                    totalRowDelviery = {
                        totalUnits: totalRowDelviery.totalUnits + val.Quantity,
                        totalFreight: totalRowDelviery.totalFreight + val.Freight,
                        totalOtherCharges: totalRowDelviery.totalOtherCharges + val.OtherCharges,
                        totalGST: totalRowDelviery.totalGST + val.GST,
                        totalAmt: totalRowDelviery.totalAmt + val.NetAmount,
                    }

                } else if (val.TransType === 'R') {
                    refundData.push({ isDataRow: true, SNo: refundData.length + 1, ...val, Date: moment(new Date(val.TransDateTime)).format("DD-MMM-YY") })
                    totalRowRefund = {
                        totalUnits: totalRowRefund.totalUnits + val.Quantity,
                        totalFreight: totalRowRefund.totalFreight + val.Freight,
                        totalOtherCharges: totalRowRefund.totalOtherCharges + val.OtherCharges,
                        totalGST: totalRowRefund.totalGST + val.GST,
                        totalAmt: totalRowRefund.totalAmt + val.NetAmount,
                    }
                }
            })
            grantTotal = {
                totalUnits: totalRowBooking.totalUnits + totalRowDelviery.totalUnits - totalRowRefund.totalUnits,
                totalFreight: totalRowBooking.totalFreight + totalRowDelviery.totalFreight - totalRowRefund.totalFreight,
                totalOtherCharges: totalRowBooking.totalOtherCharges + totalRowDelviery.totalOtherCharges - totalRowRefund.totalOtherCharges,
                totalGST: totalRowBooking.totalGST + totalRowDelviery.totalGST - totalRowRefund.totalGST,
                totalAmt: totalRowBooking.totalAmt + totalRowDelviery.totalAmt - totalRowRefund.totalAmt,
            }
            let summaryData = []
            if (txnType.find((obj) => obj.id == 'B' || obj.id == "All")) {
                if (bookingData.length > 0) {
                    summaryData.push(bookingSubHeading, bookingHeader, ...bookingData, { isTotalRow: true, caption: "Total Amount:Booking", colSpan: 7, align: 'right', ...totalRowBooking })
                } else {
                    summaryData.push(bookingSubHeading, bookingHeader, { isNoData: true, isBooking: true, caption: 'No Records', colSpan: 12 }, { isTotalRow: true, caption: "Total Amount:Booking", colSpan: 7, align: 'right', ...totalRowBooking })
                }
            }
            if (txnType.find((obj) => obj.id == 'D' || obj.id == "All")) {
                if (deliveryData.length > 0) {
                    summaryData.push(deliverySubHeading, deliveryHeader, ...deliveryData, { isTotalRow: true, caption: "Total Amount:Delivery", colSpan: 7, align: 'right', ...totalRowDelviery })
                } else {
                    summaryData.push(deliverySubHeading, deliveryHeader, { isNoData: true, isDelivery: true, caption: 'No Records', colSpan: 12 }, { isTotalRow: true, caption: "Total Amount:Delivery", colSpan: 7, align: 'right', ...totalRowDelviery })
                }
            }
            if (txnType.find((obj) => obj.id == 'R' || obj.id == "All")) {
                if (refundData.length > 0) {
                    summaryData.push(refundSubHeading, refundHeader, ...refundData, { isTotalRow: true, caption: "Total Amount:Refund", colSpan: 7, align: 'right', ...totalRowRefund })
                } else {
                    summaryData.push(refundSubHeading, refundHeader, { isNoData: true, isRefund: true, caption: 'No Records', colSpan: 12 }, { isTotalRow: true, caption: "Total Amount:Refund", colSpan: 7, align: 'right', ...totalRowRefund })
                }
            }
            setTableData([...summaryData, { isTotalRow: true, caption: `Total Amount:${data.Table2[0].Branchname}`, colSpan: 7, align: 'right', ...grantTotal }])
        }
    }

   const formatDataTwo = (data, txnType) => {
     if (!data || !data.Table) return

     const groupBy = (array, key) => {
       return array.reduce((acc, item) => {
         const groupKey = item[key] || 'UNKNOWN'
         if (!acc[groupKey]) acc[groupKey] = []
         acc[groupKey].push(item)
         return acc
       }, {})
     }

     const groupedByPaymentMode = groupBy(data.Table, 'PaymentMode')
     let finalData = []

     let grandTotal = {
       totalUnits: 0,
       totalFreight: 0,
       totalOtherCharges: 0,
       totalGST: 0,
       totalAmt: 0,
     }

     const transactionTypes = {
       B: 'Booking',
       D: 'Delivery',
       R: 'Refund',
     }

     Object.entries(groupedByPaymentMode).forEach(([paymentMode, records]) => {
       let paymentModeSection = []

       Object.entries(transactionTypes).forEach(([transCode, label]) => {
         if (!txnType.find((obj) => obj.id === transCode || obj.id === 'All')) return

         const filtered = records.filter((item) => item.TransType === transCode)
         if (filtered.length === 0) return

         let total = {
           totalUnits: 0,
           totalFreight: 0,
           totalOtherCharges: 0,
           totalGST: 0,
           totalAmt: 0,
         }

         const rows = filtered.map((val, i) => {
           const dateField = transCode === 'B' ? val.BookingDate : val.TransDateTime
           const formattedDate = moment(new Date(dateField)).format('DD-MMM-YY')

           total.totalUnits += val.Quantity
           total.totalFreight += val.Freight
           total.totalOtherCharges += val.OtherCharges
           total.totalGST += val.GST
           total.totalAmt += val.NetAmount

           return {
             isDataRow: true,
             SNo: i + 1,
             ...val,
             Date: formattedDate,
           }
         })
        if (transCode === 'R') {
            grandTotal.totalUnits -= total.totalUnits
            grandTotal.totalFreight -= total.totalFreight
            grandTotal.totalOtherCharges -= total.totalOtherCharges
            grandTotal.totalGST -= total.totalGST
            grandTotal.totalAmt -= total.totalAmt
        } else {
            grandTotal.totalUnits += total.totalUnits
            grandTotal.totalFreight += total.totalFreight
            grandTotal.totalOtherCharges += total.totalOtherCharges
            grandTotal.totalGST += total.totalGST
            grandTotal.totalAmt += total.totalAmt
        }

         const branchSubHeading = {
           isSubHeadingRow: true,
           isSubHeadingData: [
             { caption: 'Branch:', value: data.Table2[0]?.Branchname, colSpan: 4, align: 'left' },
             { caption: 'State:', value: data.Table2[0]?.Statename, colSpan: 4, align: 'center' },
             { caption: 'City Name:', value: data.Table2[0]?.Cityname, colSpan: 5, align: 'right' },
           ],
         }

         const transactionSubHeading = {
           isSubHeadingRow: true,
           isSubHeadingData: [{ caption: 'Transactions:', value: label, colSpan: 13, align: 'left' }],
         }

         const header = {
           isHeaderRow: true,
           ...(transCode === 'B'
             ? {
                 isBooking: true,
                 SNo: 'S/N',
                 LRNO: 'LR No',
                 Date: 'Bkg. Date',
                 SourceCity: 'Source',
                 DestinationCity: 'Destination',
                 PaymentType: 'Pymt. Type',
                 ConsignmentType: 'Cons. Type',
                 Quantity: 'Units',
                 Freight: 'Freight',
                 OtherCharges: 'Other Chrgs.',
                 GST: 'Bkg.GST',
                 NetAmount: 'Total Amt.',
                 Remarks: 'Remarks',
               }
             : transCode === 'D'
             ? {
                 isDelivery: true,
                 SNo: 'S/N',
                 LRNO: 'LR No',
                 Date: 'Del. Date',
                 SourceCity: 'Source',
                 DestinationCity: 'Destination',
                 PaymentType: 'Pymt. Type',
                 ConsignmentType: 'Cons. Type',
                 Quantity: 'Units',
                 Freight: 'Total LR Amt.',
                 OtherCharges: 'Net Chrgs.',
                 GST: 'Delivery GST',
                 NetAmount: 'Total Amt.',
                 Remarks: 'Remarks',
               }
             : {
                 isRefund: true,
                 SNo: 'S/N',
                 LRNO: 'LR No',
                 Date: 'Refund Date',
                 SourceCity: 'Source',
                 DestinationCity: 'Destination',
                 PaymentType: 'Pymt. Type',
                 ConsignmentType: 'Cons. Type',
                 Quantity: 'Units',
                 Freight: 'Freight',
                 OtherCharges: 'Other Chrgs.',
                 GST: 'Refund GST',
                 NetAmount: 'Total Amt.',
                 Remarks: 'Remarks',
               }),
         }

         paymentModeSection.push(header, branchSubHeading, transactionSubHeading, ...rows, {
           isTotalRow: true,
           caption: `Total Amount: ${label}`,
           colSpan: 7,
           align: 'right',
           ...total,
         })
       })

       if (paymentModeSection.length > 0) {
         finalData.push({
           isSupHeadingRow: true,
           isSubHeadingData: [{ caption: 'Payment Mode:', value: paymentMode, colSpan: 13, align: 'left' }],
         })
         finalData.push(...paymentModeSection)
       }
     })

     finalData.push({
       isTotalRow: true,
       caption: `Total Amount: ${data.Table2[0]?.Branchname}`,
       colSpan: 7,
       align: 'right',
       ...grandTotal,
     })

     setTableData(finalData)
   }


    //handle Close Alert
    const handleCloseAlert = () => {
        setShowAlert({ show: false, message: '' })
    }
    const reset = () => {
        setResetFlag(!resetFlag)
        setSelBranch('')
        setSelPaymentType([])
        setSelTransactionType([])
    }
    const onKeyDown1 = (e) => {
        navigation3(e, showTable ? isPdfLoading ? "backbtn" : disableExcel ? 'exportPdfBtn' : "excepbtn" : id.fromDate, id.reportView, generateBanchWiseReport)
    }
    return (
        <Item sx={{ padding: '0' }} className="reports">
            <ReportHeading reportName={'Branchwise Collection'} />
            <Box sx={sx.reportFlex}>
                <Item sx={sx.itemsxGrow}>
                    <DropDownOA
                        id={id.selectCompnay}
                        label={lb.select_company}
                        defaultvalue={loginData.strCompanyName}
                        disabled={true}
                        width="100%"
                    />
                </Item>
                <Item sx={sx.itemsx} className="disabled-wrapper">
                    <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} id={id.goButton} className="btn btn-primary">
                        GO
                    </Button>
                </Item>
                <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker">
                    <Datepicker
                        name={'from_collection_date'}
                        label={lb.from_collection_date}
                        id={id.fromDate}
                        width="100%"
                        dateChange={(date) => {
                            setFromDate(date)
                            focusElemnt(id.toDate)
                        }}
                    />
                </Item>
                <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker">
                    <Datepicker
                        label={lb.to_collection_date}
                        id={id.toDate}
                        width="100%"
                        dateChange={(date) => {
                            setToDate(date)
                            focusElemnt(id.selectBranch)
                        }}
                    />
                </Item>
                <Item sx={{ ...sx.itemsxGrow, flexDirection: 'column', alignItems: 'start' }}>
                    <DropDownOA
                        label={lb.selectBranch}
                        id={id.selectBranch}
                        defaultvalue={defaultBranch}
                        data={roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 1 && roleRights?.Table1?.[0]?.AllowViewAllBranchReport == 0 ? ownChildBranches.filter((val) => val.SourceBranchID == loginData?.intBranchCityID) : ownChildBranches || []}
                        dataKey={`BranchName`}
                        searchPlaceholder={`Search By Branch`}
                        idKey={`BranchID`}
                        disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0}
                        width="100%"
                        resetFlag={resetFlag}
                        onSelect={(val) => setSelBranch(val)}
                        onReset={() => setSelBranch('')}
                        prevId={id.toDate}
                        nextId={id.reportView}
                    />
                </Item>
            </Box>
            <Box sx={{ ...sx.reportFlex, justifyContent: 'start' }}>
                <Item sx={{ ...sx.itemsx, flexDirection: 'column', alignItems: 'start' }}>
                    <DropDownMultiSelect
                        label={lb.transactionType}
                        id={id.transactionType}
                        data={TransactionTypeOption}
                        searchPlaceholder={`Search By Transaction`}
                        HasAllSelect={true}
                        resetFlag={resetFlag}
                        idKey={`id`}
                        dataKey={`Name`}
                        onSelect={(val) => {
                            setSelTransactionType(val)
                        }}
                        nextId={id.reportView}
                        prevId={id.selectBranch}
                    />
                </Item>
                <Item sx={{ ...sx.itemsx, flexDirection: 'column', alignItems: 'start' }}>
                    <DropDownMultiSelect
                        label={lb.paymentType}
                        id={id.paymentBookingType}
                        data={paymentTypeOpt}
                        // data={PaymentTypesOptions}//
                        searchPlaceholder={`Search By Payment`}
                        HasAllSelect={true}
                        resetFlag={resetFlag}
                        // dataKey={`Name`}
                        dataKey={`name`}
                        idKey={'typeId'}
                        // idKey={`id`}
                        onSelect={(val) => {
                            setSelPaymentType(val)
                        }}
                        nextId={id.reportView}
                        prevId={id.transactionType}
                    />

                </Item>
                <Item sx={{ ...sx.itemsx, flexDirection: 'column', alignItems: 'start' }}>
                    <DropDownOA
                        defaultvalue={reportView?.view}
                        data={reportViewData}
                        width="100%"
                        searchPlaceholder={`Search By View`}
                        label={lb.reportView}
                        id={id.reportView}
                        tabIndex="2"
                        dataKey={`view`}
                        idKey={`id`}
                        onSelect={(value) => setReportView(value)}
                        onReset={() => setReportView('')}
                        prevId={id.selectBranch}
                        nextId={id.reportmainButton}
                    />
                </Item>
                <Item sx={sx.itemsx} onKeyDown={(e) => onKeyDown1(e)}>
                    <SplitButton
                        options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                        hideToggle={false}
                        id1={id.reportmainButton}
                        onClick1={generateBanchWiseReport}
                        onClick2={() => {
                            handleClick1(reportView)
                        }}
                    />
                </Item>
                <Item sx={{ ...sx.itemsx }} onClick={reset} >
                    <RefreshSvg />
                </Item>
            </Box>

            {showTable ?
                <>
                    <Box sx={{ ...sx.reportFlex, justifyContent: 'space-between', alignItems: 'center', marginTop: '10px' }}>
                        <Typography variant="h5" display="block" sx={{ fontWeight: 600, color: '#444' }}>
                            Report For: Branchwise Collection Report 
                        </Typography>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'center' }} className="reportButtons">
                            {!isPdfLoading ?
                                <>
                                    <Item sx={sx.itemsx} className="disabled-wrapper">
                                        {disableExcel ?
                                            <Button variant="outlined" sx={{ minWidth: '100%' }} disabled={true} className="receiveitembtn">
                                                Export to Excel
                                            </Button>
                                            :
                                            <div onKeyDown={(e) => {
                                                navigation3(e, "exportPdfBtn", id.reportmainButton, () => { })
                                            }}>
                                                <ReactHtmlTableToExcel
                                                    id="excepbtn"
                                                    className="receiveitemExcelBtn"
                                                    table="BranchwiseCollection"
                                                    filename={`Branchwise Collection Report ${currentDateTime}`}
                                                    sheet="tablexls"
                                                    buttonText="Export to Excel"
                                                />
                                            </div>
                                        }
                                    </Item>
                                    <Item sx={sx.itemsx} className="disabled-wrapper" >
                                        <Button variant="outlined" id={'exportPdfBtn'}
                                            sx={{ width: '100%' }} className="receiveitembtn"
                                            onClick={() => {
                                                printReport(true)
                                            }}
                                            onKeyDown={(e) => {
                                                navigation3(e, "pdfBtn", "excepbtn", () => printReport(true))
                                            }}
                                        >
                                            Export As PDF
                                        </Button>
                                    </Item>
                                    <Item sx={sx.itemsx} className="disabled-wrapper" >
                                        <Button variant="outlined" id={'pdfBtn'} sx={{ width: '100%' }} className="receiveitembtn"
                                            onClick={() => {
                                                printReport()
                                            }}
                                            onKeyDown={(e) => {
                                                navigation3(e, id.fromDate, "exportPdfBtn", () => printReport())
                                            }}
                                        >
                                            Print
                                        </Button>
                                    </Item>
                                </>
                                :
                                <Item sx={sx.itemsx} className="disabled-wrapper">
                                    <Button variant="outlined" id={'backbtn'} sx={{ width: '100%' }} className="receiveitembtn"
                                        onKeyDown={(e) => {
                                            navigation3(e, id.fromDate, id.reportmainButton, () => {
                                                backToScreenView()
                                                focusElemnt(id.reportmainButton)
                                            })
                                        }}
                                        onClick={backToScreenView}>
                                        Back
                                    </Button>
                                </Item>
                            }
                        </Box>
                    </Box>
                    {!isPdfLoading ?
                        <>
                            <Box sx={sx.reportFlex}>
                                <TableContainer component={Paper} className='scroll' style={{ maxHeight: '55vh', marginBottom: "22px" }} >
                                    <Table sx={{ width: '100%' }} stickyHeader aria-label="sticky table">
                                        <TableHead style={{ position: `sticky`, top: `0` }}>
                                            <TableRow>
                                                {generatereport ? <TableCell size='small' style={{ backgroundColor: '#bfe1ff', fontSize: '12px', fontWeight: 'bold', textAlign: 'left', minHeight: '36px' }} colSpan={columnDefsForSummary.length}>Summary View ({filterData.BranchName})</TableCell>
                                                    : <TableCell size='small' style={{ minHeight: '36px', backgroundColor: '#bfe1ff', fontSize: '12px', fontWeight: 'bold', textAlign: 'left' }} colSpan={columnDetailedBok.length}>Detailed View (Individual Branch)</TableCell>}
                                            </TableRow>
                                            {tableData.length == 0 &&
                                                <TableRow>
                                                    {tableData.length == 0 ?
                                                        generatereport ?
                                                            columnDefsForSummary.map((col) => (
                                                                <TableCell size='small' sx={{ minHeight: '36px' }} style={{ ...col.headerSx, backgroundColor: '#daedfe', color: '#444' }} key={`th-${col.field}`}>{col.headerName}</TableCell>
                                                            ))
                                                            :
                                                            columnDefsForSummary.map((col) => (
                                                                <TableCell size='small' sx={{ minHeight: '36px' }} style={{ ...col.headerSx, backgroundColor: '#daedfe', color: '#444' }} key={`th-${col.field}`}>{col.headerName}</TableCell>
                                                            )) : null}
                                                </TableRow>
                                            }
                                        </TableHead>
                                        <TableBody sx={{ overflow: 'scroll', height: '100%' }}>
                                            {tableData.length > 0 ? tableData.map((row, index) => (generatereport ? <SummaryTable UseToPayAsCOD={UseToPayAsCOD} row={row} index={index} columnDefs={columnDefsForSummary} /> : <DetailedTable row={row} index={index} columnDetailedBok={columnDetailedBok} columnDetailedDel={columnDetailedDel} columnDetailedRef={columnDetailedRef} />)) :
                                                <TableRow>
                                                    <TableCell size='small' sx={{ minHeight: '36px' }} colSpan={generatereport ? columnDefsForSummary.length : columnDetailedBok.length} align='center'>
                                                        <Typography variant='body1' sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                                                            No Records
                                                        </Typography>
                                                    </TableCell>
                                                </TableRow>
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                            <BranchwiseCollectionExcel UseToPayAsCOD={UseToPayAsCOD} generatereport={generatereport} loginData={loginData} filterData={filterData} filterHeader={filterHeader} columnSummaryDefs={columnDefsForSummary} columnDetailedBok={columnDetailedBok} tableData={tableData} columnDetailedDel={columnDetailedDel} columnDetailedRef={columnDetailedRef} />
                        </>
                        :
                        <Box sx={{ ...sx.reportFlex, justifyContent: 'center' }}>
                            {state.generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
                            {state.load ? (
                                <object
                                    id="output"
                                    type="application/pdf"
                                    width="100%"
                                    height="440"
                                    title="MTLPL -Cargo System - Branchwise Collection Report"
                                    aria-label="MTLPL -Cargo System - Branchwise Collection Report"
                                ></object>
                            ) : (
                                ''
                            )}
                        </Box>
                    }
                </>
                : null}
            {showAlert.show && <Alert msg={showAlert.message} error={true} close={handleCloseAlert} />}
        </Item>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getBranchList, getBranchWiseCollectionData, getOwnChildBranches }
export default connect(mapStateToProps, mapDispatchToProps)(BranchwiseCollection)